import { Community } from "../../types/Community";
import DB_PATH from "../DB_PATH";
import { firestore } from "../firebase";
import { stripLegacyCommunityReelCreatorConfig } from "./reelCreatorConfig";
import { stripLegacyCommunityMedia } from "./communityMedia";

export const createCommunity = async (
  community: Community
): Promise<string | void> => {
  const communityRef = community.id
    ? firestore.collection(DB_PATH.COMMUNITY).doc(community.id)
    : firestore.collection(DB_PATH.COMMUNITY).doc();

  const id = community.id || communityRef.id;

  console.log("Creating community with id:", id);
  const payload: Community = {
    ...(stripLegacyCommunityMedia(
      stripLegacyCommunityReelCreatorConfig(community as unknown as Record<string, unknown>)
    ) as unknown as Community),
    id,
    createdAt: community.createdAt || new Date().toISOString(),
  };

  try {
    await communityRef.set(payload);
    return id;
  } catch (error) {
    console.error("Error creating community", error);
  }
};
